<script lang="ts">import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import Modal from "../modal.svelte";
let { open = false, url = null, onClose = () => {}, title = null, iframeTitle = "Embedded content", iframeId = undefined, iframeHeight = undefined, width = "850px", maxWidth = "100vw", maxHeight = "94vh", maxHeightContent = "none", padding = "1rem", zIndexOverlay = 12e3, zIndexUnderlay = 11999, allow = "payment *; clipboard-write; geolocation; microphone; camera; autoplay; fullscreen; accelerometer; gyroscope; encrypted-media; midi; usb; xr-spatial-tracking", sandbox = "allow-same-origin allow-forms allow-scripts allow-popups allow-modals allow-pointer-lock allow-downloads allow-top-navigation-by-user-activation allow-top-navigation", referrerPolicy = "no-referrer-when-downgrade", onMessage } = $props();
let iframeLoaded = $state(false);
const useMarginTop = $derived($stateUi.iframeModal?.useMarginTop ?? false);
const iframeLoading = $derived(!!url && open && !iframeLoaded);
$effect(() => {
	const handleMessage = (event) => {
		if (!open || !onMessage) return;
		onMessage(event);
	};
	window.addEventListener("message", handleMessage);
	return () => window.removeEventListener("message", handleMessage);
});
</script>

{#if open}
	<Modal
		scrollDisabled={false}
		closeModal={onClose}
		{width}
		height={maxHeight}
		{maxWidth}
		{maxHeight}
		{maxHeightContent}
		{padding}
		{zIndexOverlay}
		{zIndexUnderlay}
		{title}
		showCloseButton={true}
		layout="fill"
		customStyleContent="overflow-y: hidden; padding: 0;"
	>
		<div
			class="iframe-container"
			style={`--iframe-max-height: ${maxHeight}; ${useMarginTop ? 'margin-top: 2rem;' : ''}`}
		>
			{#if url}
				{#if iframeLoading}
					<div class="iframe-loading">{$t(Verbiage.loading)}...</div>
				{/if}
				{#key url}
					<iframe
						class="iframe-frame"
						class:iframe-frame-explicit-height={!!iframeHeight}
						src={url}
						title={iframeTitle}
						id={iframeId}
						style={iframeHeight
							? `height: min(${iframeHeight}, calc(var(--iframe-max-height) - 8rem));`
							: undefined}
						{allow}
						allowfullscreen
						{sandbox}
						referrerpolicy={referrerPolicy}
						onload={() => (iframeLoaded = true)}
					></iframe>
				{/key}
				<div class="iframe-fallback">
					<!-- eslint-disable-next-line svelte/no-navigation-without-resolve -->
					<a href={url} target="_blank" rel="noopener noreferrer" class="iframe-fallback-link">
						{$t(Verbiage.open_in_new_tab)}
					</a>
				</div>
			{:else}
				<div class="iframe-error">
					{$t(Verbiage.something_went_wrong)}
				</div>
			{/if}
		</div>
	</Modal>
{/if}

<style>
	.iframe-container {
		width: 100%;
		padding-bottom: 0.5rem;
		display: flex;
		flex: 1 1 auto;
		flex-direction: column;
		min-height: 0;
}

	.iframe-frame {
		display: block;
		width: 100%;
		border-radius: 0.75rem;
		flex: 1 1 auto;
		min-height: 0;
		border: 0;
}

	.iframe-frame-explicit-height {
		flex: none;
	}

	.iframe-loading {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: center;
		padding-top: 1rem;
		padding-bottom: 1rem;
		text-align: center;
		opacity: 0.8;
		flex-shrink: 0;
}

	.iframe-fallback {
		margin-top: 0.5rem;
		margin-bottom: 0.25rem;
		text-align: center;
		flex-shrink: 0;
}

	.iframe-fallback-link {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		border-radius: 0.375rem;
		padding-left: 0.75rem;
		padding-right: 0.75rem;
		padding-top: 0.375rem;
		padding-bottom: 0.375rem;
		font-size: 0.875rem;
		line-height: 1.25rem;
		text-decoration-line: none;
		background-color: var(--color-primary-500);
		font-weight: 600;
		--tw-text-opacity: 1;
		color: rgb(0 0 0 / var(--tw-text-opacity, 1));
		transition: filter 0.15s ease;
}

	.iframe-fallback-link:hover {
		filter: brightness(0.95);
	}

	.iframe-error {
		width: 100%;
		padding-top: 2rem;
		padding-bottom: 2rem;
		text-align: center;
		opacity: 0.8;
}
</style>
